import { FlashList, FlashListProps as FlashListPropsBase, FlashListRef } from '@shopify/flash-list';
import { ScrollViewBase } from '@unistocks/components/basic/scrollview';
import { PropsWithoutRef } from 'react';
import Animated from 'react-native-reanimated';
import { GetProps } from 'react-redux';
import { fullscreenStyle, styled } from 'tamagui';

type NonStyleFlashListPropsBase<T> = Omit<FlashListPropsBase<T>, 'style' | 'contentContainerStyle'>;

const StyledFlashList = styled(
  FlashList,
  {
    name: 'VirtualList',
    scrollEnabled: true,
    renderScrollComponent: ScrollViewBase,

    variants: {
      fullscreen: {
        true: fullscreenStyle
      }
    } as const
  },
  {
    accept: {
      contentContainerStyle: 'style'
    } as const
  }
);

export {
  ListRenderItem,
  ListRenderItemInfo,
  useLayoutState,
  useMappingHelper,
  useRecyclingState
} from '@shopify/flash-list';
export type { ViewabilityConfig, ViewToken } from 'react-native';
export type VirtualListRef<T> = FlashListRef<T>;
export type VirtualListProps<T = any> = PropsWithoutRef<
  Omit<GetProps<typeof StyledFlashList>, keyof NonStyleFlashListPropsBase<T>> &
    NonStyleFlashListPropsBase<T>
>;

export type VirtualListType = <T>(
  props: VirtualListProps<T> & { ref?: React.Ref<VirtualListRef<T>> }
) => React.JSX.Element;

export const VirtualList = StyledFlashList as VirtualListType;

export const AnimatedVirtualList = Animated.createAnimatedComponent(VirtualList);
export type AnimatedVirtualListProps = GetProps<typeof AnimatedVirtualList>;
